import { Sprite, SpriteMaterial } from "three"
import createCenteredTextTexture from "../texture/createCenteredTextTexture"

export default function createCenteredTextSprite(
  text: string,
  padding: number = 20,
  scaleFactor: number// scales canvas size into world units
) {
  const texture = createCenteredTextTexture(text, padding)
  const material = new SpriteMaterial({ map: texture, transparent: true })
  const sprite = new Sprite(material)

  // Scale sprite based on actual canvas dimensions
  sprite.scale.set(texture.image.width * scaleFactor, texture.image.height * scaleFactor, 1)

  return sprite
}